users.service('userHistoryService', ['$http', 'uiGridConstants', 'moment', 'grid2Service', 'userHistoryResource', 'toaster',
    function ($http, uiGridConstants, moment, gridService, userHistoryResource, toaster) {
        var self = this;

        self.resource = userHistoryResource;

        self.gridApi = null;

        self.scope = null;

        self.resourceParams = {};

        var dateRangePickerOptions = {
            "locale": {
                "format": "DD/MM/YYYY",
                "separator": " - ",
                "applyLabel": "Wybierz",
                "cancelLabel": "Anuluj",
                "fromLabel": "Od",
                "toLabel": "Do",
                "customRangeLabel": "Zdefiniuj"
            },
            ranges: {
                'Dzisiaj': [moment(), moment()],
                'Wczoraj': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Z ostatnich 7 dni': [moment().subtract(6, 'days'), moment()],
                'Z ostatnich 30 dni': [moment().subtract(29, 'days'), moment()],
                'Z tego miesiąca': [moment().startOf('month'), moment().endOf('month')],
                'Z poprzedniego miesiąca': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            }
        };

        var gridColumns = [
            {
                name: 'Data zmiany',
                field: "users_history.created_at",
                fieldType: 'dateRange',
                width: '100',
                filterHeaderTemplate: '<div class="ui-grid-filter-container" ng-repeat="colFilter in col.filters"><div date-filter></div></div>',
                cellTemplate: '<div class="ui-grid-cell-contents r">{{ row.entity.created_at | amDateFormat:"DD/MM/YYYY HH:mm:ss" }}</div>'
            },
            {
                name: 'Kto zmienił',
                field: "surname",		
                fieldType: 'text',
                width: '300',
                cellTemplate: '<div class="ui-grid-cell-contents r">{{ row.entity.user_firstName }} {{ row.entity.user_surname }}</div>'
            },
            {
                name: 'Zmiana',
                field: "action",
                width: '200',
                fieldType: 'text',
            },
            {
                name: 'Opis',
                field: "description",
                fieldType: 'text',
            },

        ];


        self.getGridOptions = function () {
            gridService.query.type = 0;
            gridService.resource = self.resource;
            gridService.scope = self.scope;
            gridService.resourceParams = self.resourceParams;

            var grid2Options = gridService.getGridOptions();

            grid2Options.columnDefs = self.getGridColumns();
            return grid2Options;
        };

        self.getGridColumns = function () {
            return gridColumns;

        };

        self.getDateRangePickerOptions = function () {
            return dateRangePickerOptions;
        };

        self.getPage = function () {
            return gridService.getPage();
        };


        return self;

    }]);